import { render, staticRenderFns } from "./UsersAssignTable.vue?vue&type=template&id=1149a65a&"
import script from "./UsersAssignTable.vue?vue&type=script&lang=js&"
export * from "./UsersAssignTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports